<template>
  <div class="xq">
    <div style="width: 100%;max-width: 100%;max-height: 100%">
      <div>
        <img style="width: 100%;
      height: auto;max-height: 100%" src="../assets/img/zbss/ds1.png"/>
      </div>
    </div>
    <div class="contain">
<!--      <div class="titlesxq">-->
<!--        <div class="titlesxq-con">主办/协办赛事</div>-->
<!--        <div class="titlesxq-seccon">-->
<!--          红亚教育科技承办多个大数据相关竞赛，每年10月至11月，针对中高职院校举办大数据集群搭建与运维竞赛，2021年4月份首次举办上海市“星光计划”第九届职业院校技能大赛《Python 程序设计》项目。        </div>-->
<!--      </div>-->
      <div class="xdxtz">
        <div class="xdxtzimg">
          <img src="../assets/img/zbss/ds2.png" >
        </div>
        <div class="xdxtztitle">
          <div>
            <div class="xdxtztitle1">
              Python 程序设计技能大赛
            </div>
            <div style="width: 140px;height: 3px;background-color:black;margin:10px 0 20px 0">

            </div>
            <div class="xdxtztitle2">
              竞赛旨在通过竞赛培养中职院校学生信息技术素养，激发学生学习信息技术的热情，提高学生分析和解决实际问题的职业技能，培养学生程序设计应用创新能力。本届大赛借鉴世界技能大赛的先进理念，发挥大赛社会效应，展示职业教育成果。            </div>
          </div>
        </div>
      </div>


      <div class="xdxtz">
        <div class="xdxtztitle3">
          <div class="xdxtztitle4">
            <div class="xdxtztitle31">
              大数据分析师职业技能竞赛
            </div>
            <div style="width: 140px;height: 3px;background-color:black;margin:10px 0 20px 0;">

            </div>
            <div class="xdxtztitle2">
              通过竞赛检验参赛选手运用大数据技术解决实际问题的能力，检验参赛选手随机应变的综合职业素养，带动相关企事业单位及院校大数据人员学习大数据分析的兴趣，展现我国近几年的大数据发展成果。              <br>
            </div>
          </div>
        </div>

        <div class="xdxtzimg">
          <img src="../assets/img/zbss/ds3.png" >
        </div>
      </div>

      <div class="pics">
        <div>
          <img src="../assets/img/zbss/ds4.png" alt="">
        </div>

        <div>
          <img src="../assets/img/zbss/ds5.png" alt="">
        </div>

        <div>
          <img  src="../assets/img/zbss/ds6.png" alt="">
        </div>
      </div>

      <dv class="pics2">
        <div style="height: 100%;width: 100%;display: flex;justify-content: center;align-items: center">
          <div><img style="width: auto;max-width: 100%;height: auto;max-height: 100%" src="../assets/img/zbss/ds7.png" alt=""/></div>
          <div><img style="width: auto;max-width: 100%;height: auto;max-height: 100%" src="../assets/img/zbss/ds8.png" alt=""/></div>
          <div><img style="width: auto;max-width: 100%;height: auto;max-height: 100%" src="../assets/img/zbss/ds9.png" alt=""/></div>
          <div><img style="width: auto;max-width: 100%;height: auto;max-height: 100%" src="../assets/img/zbss/ds10.png" alt=""/></div>
          <div><img style="width: auto;max-width: 100%;height: auto;max-height: 100%" src="../assets/img/zbss/ds11.png" alt=""/></div>
        </div>
      </dv>
    </div>
  </div>
</template>

<script>
export default {
  name: "Xqhz1"
}
</script>

<style lang="scss" scoped>
img{
  width: 100%;max-width: 100%;height: 100%;max-height: 100%
}
.xq{
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  .contain{
    width: 70%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .titlesxq{
      height: 150px;
      margin-top: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .titlesxq-con{
        height: 31px;
        font-size: 32px;

        font-weight: bold;
        color: #1F2D5D;
        line-height: 18px;
      }
      .titlesxq-seccon{
        width: 100%;
        height: 80px;
        font-size: 18px;

        font-weight: 400;
        color: #6A6A6A;
        line-height: 31px;
        text-align: center;
      }
    }
    .xdxtz{
      height: 233px;
      width: 100%;
      display: flex;
      margin-top: 40px;
      .xdxtzimg{
        width: 40%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .xdxtztitle{
        width: 60%;
        height: 100%;
        display: flex;
        padding-left: 50px;
        align-items: center;
        .xdxtztitle1{
          width: 100%;
          height: 28px;
          font-size: 29px;

          font-weight: bold;
          color: #353535;
          line-height: 26px;
        }
        .xdxtztitle2{
        height: 80px;
        font-size: 18px;

        font-weight: 400;
        color: #6A6A6A;
        line-height: 31px;
        }
      }
    }

  }
}

.xdxtztitle3{
  width: 60%;
  height: 100%;
  display: flex;
  padding-right: 50px;
  align-items: center;
  justify-content: flex-end;
  .xdxtztitle4{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
    .xdxtztitle31{
      width: 100%;
      height: 28px;
      font-size: 29px;

      font-weight: bold;
      color: #353535;
      line-height: 26px;
      text-align: right;
    }
    .xdxtztitle2{
      height: 80px;
      font-size: 18px;

      font-weight: 400;
      color: #6A6A6A;
      line-height: 31px;
    }
  }
}

.pics{
  width: 100%;
  margin: 50px 0 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pics2{
  width: 100%;
  margin: 5px 0 40px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}


.imgsdiv{
  width: 30%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  img{
    width: auto;
    max-width: 100%;
    height: auto;
    max-height: 100%;
  }
}

.imgsdiv{

}
</style>
